import { cn } from "@babybjorn/ui";
import type { FC, InputHTMLAttributes } from "react";
import * as s from "./VariantItem.module.scss";

type VariantItemProps = InputHTMLAttributes<HTMLInputElement> & {
	id: string;
	image: { src: string; alt?: string };
	color: string;
	fabric?: string;
	activeVariant: string;
};

const VariantItem: FC<VariantItemProps> = ({
	id,
	image,
	color,
	fabric,
	activeVariant,
	...rest
}) => (
	<label className={cn(s.variantContainer)}>
		<input
			type="radio"
			id={id}
			name="variantPicker"
			value={id}
			onChange={() => ({})}
			className={cn(s.input, { [s.checked]: activeVariant === id })}
			aria-label={`${fabric} / ${color}`}
			{...rest}
		/>
		<img src={image.src} alt={image.alt} className={s.radioButton} />
	</label>
);

export default VariantItem;
